import { useDialog } from '@repo/ui';
import { AuthGuard } from '@repo/user-session';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useTimeout } from 'react-use';

import Layout from '@/components/layout/Layout';
import DecisionRequestLoading from '@/components/tax-refund/individual/DecisionRefund/Request/DecisionRequestLoading';

const DecisionRequestPage = () => {
  const router = useRouter();
  const [readyFn] = useTimeout(3000);
  const isReady = readyFn();
  const [isHideExitButton, setIsHideExitButton] = useState(false);
  const { showDialog } = useDialog();

  const exit = () => {
    // showDialog으로 대체: 확인 시 handleOk 실행
    showDialog({
      title: '환급 결과 확인을 그만두고 나갈까요?',
      buttons: {
        primary: {
          text: '나가기',
          onClick: () => {
            router.push({
              query: router.query
            });
          }
        },
        secondary: {
          text: '취소'
        }
      }
    });
  };

  const handleShowNetworkDisconnection = (isShow: boolean) => {
    setIsHideExitButton(isShow);
  };

  useEffect(() => {
    if (isReady) {
      // 추가로 api 응답 결과 온 이후 라우터 이동
      console.log('isReady');
    }
  }, [isReady]);

  return (
    <AuthGuard>
      {isHideExitButton ? (
        <Layout>
          <DecisionRequestLoading handleShowNetworkDisconnection={handleShowNetworkDisconnection} />
        </Layout>
      ) : (
        <Layout
          rightTextButton={{
            label: '나가기',
            state: 'gray',
            onClick: exit
          }}
        >
          <DecisionRequestLoading handleShowNetworkDisconnection={handleShowNetworkDisconnection} />
        </Layout>
      )}
    </AuthGuard>
  );
};

export default DecisionRequestPage;
